import React, { useRef } from 'react';
import CardItemSwitch from 'components/card-item-switch';
import get from 'lodash/get';
import { openLink } from 'helpers/link-helper';
import styles from './index.module.sass';
import { panFormatter } from 'helpers/credit-card-helper';
import { useAppContext } from 'use-app';
import classNames from 'classnames/bind';
import iconCheck from 'assets/icon_check.svg';
import iconFail from 'assets/icon_alert_red.svg';
const cx = classNames.bind(styles);

const Promotion = () => {
  const { state } = useAppContext();
  const promotionBoard = get(state, 'promotionBoard');
  const card = useRef();

  if (promotionBoard) {
    return promotionBoard.map(x => {
      return (
        <div
          className={styles['promotion-card']}
          ref={card}
          style={{
            backgroundImage: `url(${x.attributes.imageUrl})`,
            backgroundColor: x.attributes.backgroundColor,
            minHeight: get(card, 'current.clientWidth') * 0.4,
          }}
          onClick={() => openLink(x.attributes.url)}
        >
          <div className={styles.text}>
            <div
              className={styles.title}
              style={{
                color: x.attributes.titleColor,
              }}
            >
              {x.attributes.title}
            </div>
            <div
              className={styles.desc}
              style={{
                color: x.attributes.subtitleColor,
              }}
            >
              {x.attributes.subtitle}
            </div>
          </div>
        </div>
      );
    });
  } else {
    return <></>;
  }
};

const Hint = () => {
  const { state: appState } = useAppContext();

  if (!appState.me.currentCreditCard) return <></>;

  let { lastPaymentSuccess } = appState.me.currentCreditCard;

  const Content = () => {
    if (!lastPaymentSuccess) {
      return (
        <>
          <img src={iconFail} alt="icon-fail" />
          前一筆交易卡片授權失敗，請洽詢發卡行或重新設定。
        </>
      );
    }

    return (
      <>
        <img src={iconCheck} alt="icon-check" />
        付款方式已設定，歡迎使用。
      </>
    );
  };

  const hintClass = cx({
    hint: true,
    error: !lastPaymentSuccess,
  });

  return (
    <div className={hintClass}>
      <Content />
    </div>
  );
};

const BindCard = ({ isOnBoarding = false, currentPoints, onSwitchClick, settingButton = '' }) => {
  const { state: appState } = useAppContext();
  const card = appState.me?.currentCreditCard;

  const cardClass = cx({
    card: true,
    d: card.creditCardCategory?.name === '全國大利卡',
    l: card.creditCardCategory.name !== '全國大利卡',
  });

  return (
    <>
      <div className={styles['bind-card']}>
        <div className={cardClass}>
          <div className={styles.default}>
            {card.creditCardCategory.name === '全國大利卡' && '預設'}
            {settingButton}
          </div>
          <div className={styles['card-content']}>
            <div className={styles['bank']}>{card.creditCardCategory.name}</div>
            {card.creditCardCategory.name === '全國大利卡' && <div className={styles.normal}>一般信用卡</div>}
          </div>
          <div className={styles['last-four-code']}>
            {panFormatter(card.firstSixCode)}
            <span>·· ···· </span>
            {card.lastFourCode}
          </div>
        </div>
        {!isOnBoarding && <Hint />}
        <CardItemSwitch
          title="加油幣折抵"
          switchState={card.redeemBonusPoints.enableCreditPointRedeem ? 'on' : 'off'}
          subText={
            <>
              <div style={{ textAlign: 'left' }}>
                目前加油幣： <span style={{ color: '#F4B527' }}>{currentPoints}</span>
              </div>
              <ul className={styles['discount-hint']}>
                <li>1 點等於 1 元，折抵上限 50%</li>
                <li>僅可於非公有停車場折抵</li>
                <li>以交易時全國系統數量為準</li>
              </ul>
            </>
          }
          isChecked={card.redeemBonusPoints.enableCreditPointRedeem}
          onChange={onSwitchClick}
        />
        {!isOnBoarding && (
          <div className={styles['promotion']}>
            <Promotion />
          </div>
        )}
      </div>
    </>
  );
};

export default BindCard;
